import { LANG_OPTIONS } from "@/lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function LanguageSelector({ value, onChange, compact = false }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="language-selector"
        className={compact ? "w-[110px] h-9 bg-white/60 border-border/50" : "w-[140px]"}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANG_OPTIONS.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>
            <span className="mr-2">{l.flag}</span>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
